import { createElement } from 'react';

interface JsonLdProps {
  data: unknown;
  id?: string;
}

export const serializeJsonLd = (data: unknown): string =>
  JSON.stringify(data).replace(/</g, '\\u003c');

export const JsonLd = ({ data, id }: JsonLdProps) =>
  createElement('script', {
    id,
    type: 'application/ld+json',
    dangerouslySetInnerHTML: { __html: serializeJsonLd(data) },
  });
